// extracted by mini-css-extract-plugin
module.exports = {"container":"hO1zS","wrapper":"_2dNYa","listItemMobile":"_15Juu","pagination":"_3OHEf","separator":"D2FkD"};